/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/destructuring-assignment */

import React from "react";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../App/Analytics";

import {
  InlinePlayableTawkPill,
  InlinePlayableTawkPillConfig,
  inlinePlayableTawkPillConfigDemo1 as inlinePlayableDemoProps1,
} from "../InlinePlayableTawkPill/InlinePlayableTawkPill";
import {
  TopAnnotation,
  TopAnnotationConfig,
  topAnnotationDemoProps1,
} from "../TopAnnotation/TopAnnotation";
import {
  InteractionBar,
  InteractionBarConfig,
  demoProps1 as interactionBarDemoProps1,
} from "../InteractionBar/InteractionBar";
import "./NonRecursivePostCard.css";
import {
  TextBubble,
  TextBubbleConfig,
  textBubbleConfigDemo1 as textBubbleDemoProps,
} from "../TextBubble/TextBubble";
import { Echo, EchoConfig } from "../Echo/Echo";

import { assertUnreachable } from "../../Infrastucture/MissingStd";

export type NonRecursivePostCardPrimaryContnetConfig =
  | InlinePlayableTawkPillConfig
  | TextBubbleConfig
  | EchoConfig;
export interface NonRecursivePostCardConfig {
  interactionBarConfig: InteractionBarConfig;
  primaryContentConfig: NonRecursivePostCardPrimaryContnetConfig;
  topAnnotationBarConfig: TopAnnotationConfig;
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  analyticsParams: { [key: string]: any };
  /* eslint-enable  @typescript-eslint/no-explicit-any */
}

export const nonRecursivePostCardConfigDemo1TawkPill: NonRecursivePostCardConfig =
  {
    interactionBarConfig: interactionBarDemoProps1,
    primaryContentConfig: inlinePlayableDemoProps1,
    topAnnotationBarConfig: topAnnotationDemoProps1,
    analyticsParams: {},
  };

export const nonRecursivepostCardConfigDemo2TextBubble: NonRecursivePostCardConfig =
  {
    interactionBarConfig: interactionBarDemoProps1,
    primaryContentConfig: textBubbleDemoProps,
    topAnnotationBarConfig: topAnnotationDemoProps1,
    analyticsParams: {},
  };

function isAnInlinePlayableConfig(
  obj: NonRecursivePostCardPrimaryContnetConfig
): obj is InlinePlayableTawkPillConfig {
  return obj.kind === "InlinePlayableTawkPillConfig";
}
function isATextBubbleConfig(
  obj: NonRecursivePostCardPrimaryContnetConfig
): obj is TextBubbleConfig {
  return obj.kind === "TextBubbleConfig";
}
function isAnEchoConfig(
  obj: NonRecursivePostCardPrimaryContnetConfig
): obj is EchoConfig {
  return obj.kind === "EchoConfig";
}

function NonRecursivePostCardPrimaryContent(
  props: NonRecursivePostCardPrimaryContnetConfig
): JSX.Element {
  if (isAnInlinePlayableConfig(props)) {
    return <InlinePlayableTawkPill {...props} />;
  }
  if (isATextBubbleConfig(props)) {
    return <TextBubble {...props} />;
  }
  if (isAnEchoConfig(props)) {
    return <Echo {...props} />;
  }

  assertUnreachable(props);
}

export function NonRecursivePostCard(
  props: NonRecursivePostCardConfig
): JSX.Element {
  logEvent(analytics, "non_recursive_post_card_view", {
    firebase_screen: "NonRecursivePostCard",
    firebase_screen_class: "NonRecursivePostCard",
    ...props.analyticsParams,
  });

  return (
    <div className="non-recursive-post-card">
      <div
        className="non-recursive-post-card-internal"
        style={
          {
            // gap: "10px",
          }
        }
      >
        <div className="non-recursive-post-card-top-annotation">
          <TopAnnotation {...props.topAnnotationBarConfig} />
        </div>

        <div className="non-recursive-post-card-primary-content">
          <NonRecursivePostCardPrimaryContent {...props.primaryContentConfig} />
        </div>

        <div className="non-recursive-post-card-bottom-interaction-bar">
          <InteractionBar {...props.interactionBarConfig} />
        </div>
      </div>
    </div>
  );
}
